import { ContentTypeEnum } from 'src/common/interfaces/content/type.enum';
import { Node } from 'src/common/interfaces/node.interface';
import { MAX_NAME_LENGTH } from 'src/editor/step-editor/use-submit-step-form';

// ref: getNodeParams
export const getFormParamsByNode = (node: Node): object => {
  let params = {};
  const baseParams = {
    name: node.name.substring(0, MAX_NAME_LENGTH),
  };

  if (node.embed) {
    params = { ...baseParams, url: node.embed.url, node_type: ContentTypeEnum.EMBED };
  } else if (node.content_type === ContentTypeEnum.EXTERNAL_LINK) {
    params = { ...baseParams, link_url: node.external_link?.url, link_name: node.name };
  } else if (node.content_type === ContentTypeEnum.FILE) {
    params = { ...baseParams, file_asset_id: node.file_asset?.id };
  } else if (node.content_type === ContentTypeEnum.JOURNEY_DOCUMENT) {
    params = { ...baseParams, document_id: node.document?.id };
  } else if (node.content_type === ContentTypeEnum.PDF) {
    params = { ...baseParams, file_asset_id: node.file_asset?.id };
  } else if (node.content_type === ContentTypeEnum.IMAGE) {
    params = { ...baseParams, image_asset_id: node.image_asset.id };
  } else if (node.content_type === ContentTypeEnum.VIDEO) {
    params = { ...baseParams, video_uuid: node.video_asset?.uuid };
  }

  return params;
};
